<div class='modal-backdrop'>
  <div class='modal-dialog'>
    <div class='modal-content'>
      <div class='modal-header'>
        <h4 class='modal-title'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.DETAILS.TITLE' | translate }}</h4>
      </div>
      <div class='modal-body scrollbar' id='body-container'>
        @if (orderItem.description) {
          <p>{{ orderItem.description }}</p>
        }
        @if (additionalInformationsArray?.length > 0) {
          <h5 class='additional-informations-title'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.DETAILS.ADDITIONAL_INFORMATION' | translate }}</h5>
          <div class='scrollbar' id='tab-informations'>
            <table class='table'>
              <thead>
                <tr>
                  <th>{{ 'COMMON.LABELS.' + displayedColumns[0] | translate }}</th>
                  <th>{{ 'COMMON.LABELS.' + displayedColumns[1] | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (item of additionalInformationsArray; track item) {
                  <tr>
                    <td class='cell'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.DETAILS.ADDITIONAL_INFORMATION_LABELS.KEY.' + item.name | translateIfExist: item.name | noData }}</td>
                    <td class='cell'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.ORDER.ITEMS_LIST.DETAILS.ADDITIONAL_INFORMATION_LABELS.VALUE.' + item.value | translateIfExist: item.value | noData }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
      <div class='modal-footer'>
        <button type='button' class='btn pull-right' (click)='closeModal()'>{{ 'ACTIONS.CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
